module.exports = __webpack_public_path__ + "img/pen-write-paper.85618361.svg";